<script>
import navbar from "./components/navbar.vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import customMessage from "./components/customMessage.vue";
import loadingAnimation from "./components/loadingAnimation.vue";
export default {
  name: "App",
  components: {
    navbar,
    customMessage,
    loadingAnimation,
  },
  methods: {
    onResize: function() {
      this.setScreenSize();
    },
    setScreenSize: function() {
      this.$store.commit("setWindowSize", { width: window.innerWidth, height: window.innerHeight });
    },
    getBodyClass() {
      var result = "";
      if (this.isMobile) {
        return "mobile-layout";
      } else if (this.isNavExpanded) {
        if (this.navbarExpandedOverlay) {
          return "overlay expanded-nav";
        } else {
          return "expanded-nav";
        }
      } else {
        return "collapsed-nav";
      }
    },
  },
  computed: {
    showLoader: function() {
      return this.$store.state.showLoader;
    },
    isAuthorized: function() {
      return this.$store.state.userId && this.$store.state.role && this.$store.state.name;
    },
    isNavExpanded: function() {
      return this.$store.state.isNavExpanded;
    },
    isMobile: function() {
      return this.$store.state.isMobile;
    },
    containerFluid() {
      return this.$store.state.windowWidth < 1201;
    },
    navbarExpandedOverlay() {
      return this.$store.state.navbarExpandedOverlay;
    },
  },
  mounted() {
    this.onResize();
    var self = this;
    window.addEventListener("resize", self.onResize);
  },
  watch: {
    $route(to, from) {
      if (from) {
        this.$store.commit("setActiveNav", to.name);
      }
    },
  },
};
</script>
<template>
  <div :class="getBodyClass()">
    <custom-message></custom-message>
    <navbar v-if="isAuthorized"></navbar>
    <div :class="[containerFluid ? 'container-fluid' : 'container']">
      <router-view />
    </div>
    <loading-animation v-if="showLoader"></loading-animation>
  </div>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.expanded-nav:not(.overlay) {
  margin-left: 250px;
}
.collapsed-nav {
  margin-left: 75px;
}
.mobile-layout {
  padding-bottom: 75px;
  padding-top: 50px;
}
.overlay .container {
  opacity: 0.6;
}
</style>
